import React from 'react';
import SharedCardParameter from '@src/pages/ticketShared/cardOrders/cardInformation/CardParameter';
import { VouIdCode } from '@src/store/enums';

const Wrapper = (props) => <SharedCardParameter vouId={VouIdCode.Compliments} {...props} />;

export default Wrapper;
